
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Products from './components/Products';
import Profile from './components/Profile';
import Certifications from './components/Certifications';
import Dealerships from './components/Dealerships';
import RepairingAndServiceContracts from './components/RepairingAndServiceContracts';
import ClientList from './components/ClientList';
import Contact from './components/Contact';
import Header from './components/Header';
import Ups from './components/product_items/Ups'; 
import Stabilizer from './components/product_items/Stabilizer';
import LineConditioner from './components/product_items/LineConditioner';
import Solar from './components/product_items/Solar';
import ManualRegulator from './components/product_items/ManualRegulator';
import Battery from './components/product_items/Battery';
import Transformer from './components/product_items/Transformer';
import Footer from './components/Footer';
import UpsSubpages from './components/product_items/Ups_cat/UpsSubpages';
import StabilizerSubpages from './components/product_items/Stabilizer_cat/StabilizerSubpages';

import SolarSubpages from './components/product_items/Solar_cat/SolarSubpages';
import ManualRegulatorSubpages from './components/product_items/ManualRegulator_cat/ManualRegulatorSubpages';
import BatterySubpages from './components/product_items/Battery_cat/BatterySubpages';

import PageNotFound from "./components/PageNotFound";

// Layout Component (with Navbar, Header, and Footer)
const Layout = ({ children }) => (
<div>
  <Header />
  <Navbar />
  {children}
  <Footer />
</div>
);
const App = () => {
  return (
    <Router>   
      <ScrollToTop /> 
      
      <div>
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/products" element={<Layout><Products /></Layout>} />

          <Route path="/product_items/Ups" element={<Layout><Ups /></Layout>} />
          <Route path="/product_items/Ups_cat/UpsSubpages/:id" element={<Layout><UpsSubpages/></Layout>} />
          <Route path="/product_items/Stabilizer" element={<Layout><Stabilizer /></Layout>} />
          <Route path="/product_items/Stabilizer_cat/StabilizerSubpages/:id" element={<Layout><StabilizerSubpages/></Layout>} />
          <Route path="/product_items/LineConditioner" element={<Layout><LineConditioner /></Layout>} />
          <Route path="/product_items/Solar" element={<Layout><Solar /></Layout>} />
          <Route path="/product_items/Solar_cat/SolarSubpages/:id" element={<Layout><SolarSubpages/></Layout>} />
          <Route path="/product_items/ManualRegulator" element={<Layout><ManualRegulator /></Layout>} />
          <Route path="/product_items/ManualRegulator_cat/ManualRegulatorSubpages/:id" element={<Layout><ManualRegulatorSubpages /></Layout>} />
          <Route path="/product_items/Battery" element={<Layout><Battery /></Layout>} />
          <Route path="/product_items/Battery_cat/BatterySubpages/:id" element={<Layout><BatterySubpages /></Layout>} />
          <Route path="/product_items/Transformer" element={<Layout><Transformer /></Layout>} />
          <Route path="/profile" element={<Layout><Profile /></Layout>} />
          <Route path="/certifications" element={<Layout><Certifications /></Layout>} />
          <Route path="/dealerships" element={<Layout><Dealerships /></Layout>} />
          <Route path="/repairingandservicecontracts" element={<Layout><RepairingAndServiceContracts /></Layout>} />
          <Route path="/clientlist" element={<Layout><ClientList /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
    <Route path="*" element={<PageNotFound />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
